export default "__VITE_ASSET__Dxne8BEN__"